"use strict";

var _Reflect$construct = require("@babel/runtime-corejs3/core-js-stable/reflect/construct");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _map = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/map"));

var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/concat"));

var _slice = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/slice"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Button = _interopRequireDefault(require("reactstrap/lib/Button"));

var _Dropdown = _interopRequireDefault(require("reactstrap/lib/Dropdown"));

var _DropdownToggle = _interopRequireDefault(require("reactstrap/lib/DropdownToggle"));

var _DropdownMenu = _interopRequireDefault(require("reactstrap/lib/DropdownMenu"));

var _DropdownItem = _interopRequireDefault(require("reactstrap/lib/DropdownItem"));

var _utils = require("../lib/utils");

var _button = _interopRequireDefault(require("../button/button"));

require("./actionButtons.css");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = _Reflect$construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_Reflect$construct) return false; if (_Reflect$construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(_Reflect$construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var ActionButtons = /*#__PURE__*/function (_React$PureComponent) {
  (0, _inherits2["default"])(ActionButtons, _React$PureComponent);

  var _super = _createSuper(ActionButtons);

  function ActionButtons(props) {
    var _this;

    (0, _classCallCheck2["default"])(this, ActionButtons);
    _this = _super.call(this, props);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "getDropDown", function (items) {
      var _this$props = _this.props,
          disableMoreBtn = _this$props.disableMoreBtn,
          allInMore = _this$props.allInMore,
          className = _this$props.className,
          moreBtnSize = _this$props.moreBtnSize,
          rightAligned = _this$props.rightAligned;
      var isOpen = _this.state.isOpen;
      var mainClass = (0, _utils.gatherClasses)(null, "oui-popup-action-buttons-wrapper", allInMore ? className : null);
      return /*#__PURE__*/_react["default"].createElement(_Dropdown["default"], {
        inNavbar: true,
        isOpen: isOpen,
        toggle: _this.toggle,
        className: mainClass
      }, /*#__PURE__*/_react["default"].createElement(_DropdownToggle["default"], {
        tag: "div",
        disabled: disableMoreBtn
      }, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
        disabled: disableMoreBtn,
        className: "oui-popup-toggle-btn",
        color: "primary",
        outline: true,
        size: moreBtnSize,
        "aria-label": "show more"
      }, /*#__PURE__*/_react["default"].createElement("svg", {
        className: "oui-more-icon-svg",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 12 48"
      }, /*#__PURE__*/_react["default"].createElement("circle", {
        cx: "6",
        cy: "6",
        r: "6"
      }), /*#__PURE__*/_react["default"].createElement("circle", {
        cx: "6",
        cy: "24",
        r: "6"
      }), /*#__PURE__*/_react["default"].createElement("circle", {
        cx: "6",
        cy: "42",
        r: "6"
      })))), /*#__PURE__*/_react["default"].createElement(_DropdownMenu["default"], {
        right: rightAligned,
        className: "popup-action-buttons"
      }, (0, _map["default"])(items).call(items, function (item) {
        return /*#__PURE__*/_react["default"].createElement(_DropdownItem["default"], {
          className: "popup-action-btn dropdown-item",
          key: item.label,
          onClick: item.onClick,
          disabled: item.disabled
        }, item.label);
      })));
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "toggle", function () {
      var isOpen = _this.state.isOpen;

      _this.setState({
        isOpen: !isOpen
      });
    });
    _this.state = {
      isOpen: false
    }; // eslint-disable-next-line no-console

    console.warn("[Deprecation] ActionButtons is deprecated from Orion. Use <Dropdown type='secondary' icon={{ classes:'di di-more' }} /> instead.");
    return _this;
  }

  (0, _createClass2["default"])(ActionButtons, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          buttons = _this$props2.buttons,
          allInMore = _this$props2.allInMore,
          dataTestId = _this$props2.dataTestId;
      var nButtons = buttons.length; // No buttons provided

      if (!nButtons) return null; // If allInMore is true, put all the buttons inside more dropdown

      if (allInMore) {
        return this.getDropDown(buttons);
      } // Exactly 2 buttons provided


      if (nButtons <= 2) {
        return /*#__PURE__*/_react["default"].createElement("div", {
          className: (0, _utils.gatherClasses)(this.props, "action-btn-wpr")
        }, (0, _map["default"])(buttons).call(buttons, function (button, index) {
          var _context;

          return /*#__PURE__*/_react["default"].createElement(_button["default"], {
            key: (0, _concat["default"])(_context = "".concat(button.label, "-")).call(_context, index),
            type: button.type,
            size: button.size,
            className: (0, _utils.gatherClasses)(null, button.className, index !== buttons.length - 1 ? "mr-3" : null),
            onClick: button.onClick,
            disabled: button.disabled,
            label: button.label
          });
        }));
      } // More than 2 buttons provided


      var firstButton = buttons[0];
      var firstButtonClasses = (0, _utils.gatherClasses)(null, "mr-3", firstButton.className);
      return /*#__PURE__*/_react["default"].createElement("div", {
        "data-testid": dataTestId,
        className: (0, _utils.gatherClasses)(this.props, "action-btn-wpr")
      }, /*#__PURE__*/_react["default"].createElement(_button["default"], {
        type: firstButton.type,
        size: firstButton.size,
        className: firstButtonClasses,
        onClick: firstButton.onClick,
        disabled: firstButton.disabled,
        label: firstButton.label
      }), this.getDropDown((0, _slice["default"])(buttons).call(buttons, 1)));
    }
  }]);
  return ActionButtons;
}(_react["default"].PureComponent);

ActionButtons.propTypes = {
  className: _propTypes["default"].string,
  buttons: _propTypes["default"].arrayOf(_propTypes["default"].object).isRequired,
  allInMore: _propTypes["default"].bool,
  rightAligned: _propTypes["default"].bool,
  moreBtnSize: _propTypes["default"].oneOf(["sm", "md", "lg"]),
  disableMoreBtn: _propTypes["default"].bool,
  dataTestId: _propTypes["default"].string
};
ActionButtons.defaultProps = {
  className: "",
  // eslint-disable-next-line react/default-props-match-prop-types
  buttons: [],
  allInMore: false,
  rightAligned: true,
  moreBtnSize: "md",
  disableMoreBtn: false,
  dataTestId: "orion-action-buttons"
};
ActionButtons.displayName = "OrionActionButtons";
var _default = ActionButtons;
exports["default"] = _default;